import { render } from "./PrevPageLink.vue?vue&type=template&id=5ab8d86c"
import script from "./PrevPageLink.vue?vue&type=script&lang=js"
export * from "./PrevPageLink.vue?vue&type=script&lang=js"
script.render = render

export default script